//基础
import index from "../views/index";
//人员
import staff from "../views/staff";
//材料
import metrial from "../views/metrial";
//视频
import video from "../views/video";
//工程态势
import situation from "../views/situation";
//设备
import equipment from "../views/equipment";
//环境
import environment from "../views/environment";

const staticRouter = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/environment",
    name: "environment",
    component: environment,
  },
  {
    path: "/equipment",
    name: "equipment",
    component: equipment,
  },
  {
    path: "/situation",
    name: "situation",
    component: situation,
  },
  {
    path: "/video",
    name: "video",
    component: video,
  },
  {
    path: "/metrial",
    name: "metrial",
    component: metrial,
  },
  {
    path: "/staff",
    name: "staff",
    component: staff,
  },
  {
    path: "/index",
    name: "index",
    component: () => import('../views/index'),
  },
];

export default staticRouter;